export const mapClients = (values) => {
  const mappedClients = values.map((item) => ({
    name: item.client_id,
    label: item.name
  }));

  return mappedClients;
};
